import { defineStore } from 'pinia';
import { LxNotifyStore } from '@dativa-lv/lx-ui';

export default defineStore('notifyStore', LxNotifyStore);
